module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table2"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("表 1-2：资质情况表 ———— 音像制品出版许可证")]) : _c('span', [_vm._v("表 1-2：资质情况表 ———— 电子出版物出版许可证")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.getcode202HistoryData
    }
  }, [_vm._v("导入历史数据")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版许可证号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "xkzNum",
      "inline-message": true
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请输入出版许可证号"
    },
    model: {
      value: (_vm.params.xkzNum),
      callback: function($$v) {
        _vm.$set(_vm.params, "xkzNum", $$v)
      },
      expression: "params.xkzNum"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "orgName",
      "inline-message": true
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请输入出版许可证号上“单位名称”项"
    },
    model: {
      value: (_vm.params.orgName),
      callback: function($$v) {
        _vm.$set(_vm.params, "orgName", $$v)
      },
      expression: "params.orgName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位地址：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "orgAddr",
      "inline-message": true
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请输入出版许可证号上“单位地址”项"
    },
    model: {
      value: (_vm.params.orgAddr),
      callback: function($$v) {
        _vm.$set(_vm.params, "orgAddr", $$v)
      },
      expression: "params.orgAddr"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版者码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "cbzMa",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入出版许可证号上“出版者码”项"
    },
    model: {
      value: (_vm.params.cbzMa),
      callback: function($$v) {
        _vm.$set(_vm.params, "cbzMa", $$v)
      },
      expression: "params.cbzMa"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "tips"
  }, [_vm._v("注：若没有，请填写“无”")])], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("法定代表人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "fddbr",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入出版许可证号上“法定代表人”项"
    },
    model: {
      value: (_vm.params.fddbr),
      callback: function($$v) {
        _vm.$set(_vm.params, "fddbr", $$v)
      },
      expression: "params.fddbr"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("有效日期：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "yxStartDate",
      "inline-message": true
    }
  }, [_c('el-date-picker', {
    attrs: {
      "value-format": "yyyy-MM-dd",
      "placeholder": "开始日期",
      "size": "small"
    },
    on: {
      "change": function($event) {
        _vm.changeHandle(1)
      }
    },
    model: {
      value: (_vm.params.yxStartDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "yxStartDate", $$v)
      },
      expression: "params.yxStartDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "midSpan"
  }, [_vm._v("至")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "yxEndDate",
      "inline-message": true
    }
  }, [_c('el-date-picker', {
    attrs: {
      "value-format": "yyyy-MM-dd",
      "placeholder": "结束日期",
      "size": "small"
    },
    on: {
      "change": function($event) {
        _vm.changeHandle(2)
      }
    },
    model: {
      value: (_vm.params.yxEndDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "yxEndDate", $$v)
      },
      expression: "params.yxEndDate"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版范围：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "businessScope",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 8,
      "size": "small",
      "placeholder": "请输入出版许可证号上“出版范围”项"
    },
    model: {
      value: (_vm.params.businessScope),
      callback: function($$v) {
        _vm.$set(_vm.params, "businessScope", $$v)
      },
      expression: "params.businessScope"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("其他主要业务：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "otherScope",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "size": "small",
      "placeholder": "请填写除音像电子出版业务外本单位或本部门经营的其他主要业务"
    },
    model: {
      value: (_vm.params.otherScope),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherScope", $$v)
      },
      expression: "params.otherScope"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "tips"
  }, [_vm._v("注：若没有，请填写“无”")])], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版单位设立获批时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "approvalTime",
      "inline-message": true
    }
  }, [_c('el-date-picker', {
    attrs: {
      "align": "right",
      "type": "date",
      "size": "small",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.params.approvalTime),
      callback: function($$v) {
        _vm.$set(_vm.params, "approvalTime", $$v)
      },
      expression: "params.approvalTime"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "tips"
  }, [_vm._v("注：请填写出版单位最早获得批复的发文时间")])], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("上传发文文件：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('UpbtnPdf', {
    staticClass: "upBtn",
    attrs: {
      "fileID": _vm.publishFileId
    },
    on: {
      "upFileId": _vm.fileTdSetPublishFileId
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips",
    staticStyle: {
      "margin-top": "5px",
      "line-height": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("注：")]), _vm._v("上传最早获得国家出版行政管理部门批复的发文文件，如果无法上传，请上传加盖社章的情况说明文件。\n              "), _c('br'), _vm._v("\n                     上传文件格式为PDF，文件大小不超过10M\n            ")])], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("需要说明的其他情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "size": "small",
      "placeholder": "请输入需要说明的其他情况"
    },
    model: {
      value: (_vm.params.otherSituation),
      callback: function($$v) {
        _vm.$set(_vm.params, "otherSituation", $$v)
      },
      expression: "params.otherSituation"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName uploadLine"
  }, [_vm._v("上传出版许可证：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('span', {
    staticStyle: {
      "color": "red",
      "line-height": "24px"
    }
  }, [_vm._v("\n              注：按照五张图片的上传要求，逐一上传出版许可证相应页面，每张图片必须提供许可证的某一页，不能一张图片中包含多页内容。\n              "), _c('br'), _vm._v("\n              图片上传时要注意图片是否全部旋转到正确的方向，不得出现竖版图片横放的情况。点击图片大图模式下可以调整方向。\n              "), _c('br'), _vm._v("\n              每页只能上传一个图片，上传文件格式为JPEG/PNG，文件大小不超过10M。\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "imgblock"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.xkzFileId1,
      "btnProps": {
        colId: 'xkzFileId1'
      }
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgblocktag"
  }, [_vm._v("出版许可证正本")])], 1), _vm._v(" "), _c('div', {
    staticClass: "imgblock"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.xkzFileId2,
      "btnProps": {
        colId: 'xkzFileId2'
      }
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgblocktag"
  }, [_vm._v("出版许可证副本盖章页")])], 1), _vm._v(" "), _c('div', {
    staticClass: "imgblock"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.xkzFileId3,
      "btnProps": {
        colId: 'xkzFileId3'
      }
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgblocktag"
  }, [_vm._v("出版许可证副本单位信息页")])], 1), _vm._v(" "), _c('div', {
    staticClass: "imgblock"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.xkzFileId4,
      "btnProps": {
        colId: 'xkzFileId4'
      }
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgblocktag"
  }, [_vm._v("出版许可证副本年度核验记录页")])], 1), _vm._v(" "), _c('div', {
    staticClass: "imgblock"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.xkzFileId5,
      "btnProps": {
        colId: 'xkzFileId5'
      }
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgblocktag"
  }, [_vm._v("出版许可证副本变更记录页")])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("主办及主管单位信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("主办单位：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "hostName",
      "inline-message": true
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请输入主办单位名称"
    },
    model: {
      value: (_vm.params.hostName),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostName", $$v)
      },
      expression: "params.hostName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位性质：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.params.hostType),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostType", $$v)
      },
      expression: "params.hostType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '1'
    }
  }, [_vm._v("中央")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '2'
    }
  }, [_vm._v("地方")])], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "hostCategory",
      "width": "200px"
    }
  }, [_c('el-select', {
    attrs: {
      "width": "200px",
      "size": "small",
      "placeholder": "请选择主办单位性质"
    },
    model: {
      value: (_vm.params.hostCategory),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostCategory", $$v)
      },
      expression: "params.hostCategory"
    }
  }, _vm._l((_vm.cats), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), (_vm.params.hostCategory == '5') ? _c('el-form-item', {
    attrs: {
      "prop": "hostOtherCategory",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "需要填写具体主办单位性质"
    },
    model: {
      value: (_vm.params.hostOtherCategory),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostOtherCategory", $$v)
      },
      expression: "params.hostOtherCategory"
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("地址：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "hostAddr",
      "inline-message": true
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请输入主办单位地址"
    },
    model: {
      value: (_vm.params.hostAddr),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostAddr", $$v)
      },
      expression: "params.hostAddr"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("邮政编码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "hostPostalcode",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入主办单位邮政编码"
    },
    model: {
      value: (_vm.params.hostPostalcode),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostPostalcode", $$v)
      },
      expression: "params.hostPostalcode"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "hostLinkman",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入主办单位联系人"
    },
    model: {
      value: (_vm.params.hostLinkman),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostLinkman", $$v)
      },
      expression: "params.hostLinkman"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系电话：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "hostTel",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入主办单位联系人座机号码"
    },
    model: {
      value: (_vm.params.hostTel),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostTel", $$v)
      },
      expression: "params.hostTel"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("手机号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "hostPhone",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入主办单位联系人手机号码"
    },
    model: {
      value: (_vm.params.hostPhone),
      callback: function($$v) {
        _vm.$set(_vm.params, "hostPhone", $$v)
      },
      expression: "params.hostPhone"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("主管单位：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "chargeName",
      "inline-message": true
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请输入主管单位名称"
    },
    model: {
      value: (_vm.params.chargeName),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargeName", $$v)
      },
      expression: "params.chargeName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("单位性质：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.params.chargeType),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargeType", $$v)
      },
      expression: "params.chargeType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '1'
    }
  }, [_vm._v("中央")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '2'
    }
  }, [_vm._v("地方")])], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }), _vm._v(" "), _c('td', {
    staticClass: "edInp edSelect"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "chargeCategory",
      "width": "200px"
    }
  }, [_c('el-select', {
    attrs: {
      "width": "200px",
      "size": "small",
      "placeholder": "请选择主管单位性质"
    },
    model: {
      value: (_vm.params.chargeCategory),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargeCategory", $$v)
      },
      expression: "params.chargeCategory"
    }
  }, _vm._l((_vm.cats), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1), _vm._v(" "), (_vm.params.chargeCategory == '5') ? _c('el-form-item', {
    attrs: {
      "prop": "chargeOtherCategory",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "需要填写具体主管单位性质"
    },
    model: {
      value: (_vm.params.chargeOtherCategory),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargeOtherCategory", $$v)
      },
      expression: "params.chargeOtherCategory"
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("地址：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "chargeAddr",
      "inline-message": true
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请输入主管单位地址"
    },
    model: {
      value: (_vm.params.chargeAddr),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargeAddr", $$v)
      },
      expression: "params.chargeAddr"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("邮政编码：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "chargePostalcode",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入主管单位邮政编码"
    },
    model: {
      value: (_vm.params.chargePostalcode),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargePostalcode", $$v)
      },
      expression: "params.chargePostalcode"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "chargeLinkman",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入主管单位联系人"
    },
    model: {
      value: (_vm.params.chargeLinkman),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargeLinkman", $$v)
      },
      expression: "params.chargeLinkman"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系电话：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "chargeTel",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入主管单位联系人座机号码"
    },
    model: {
      value: (_vm.params.chargeTel),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargeTel", $$v)
      },
      expression: "params.chargeTel"
    }
  })], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("手机号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "chargePhone",
      "inline-message": true
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入主管单位联系人手机号码"
    },
    model: {
      value: (_vm.params.chargePhone),
      callback: function($$v) {
        _vm.$set(_vm.params, "chargePhone", $$v)
      },
      expression: "params.chargePhone"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入申报人联系方式"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "disabled": true
    },
    model: {
      value: (_vm.params.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.params, "updatedAt", $$v)
      },
      expression: "params.updatedAt"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.pubStatus == 0) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": _vm.submiting
    },
    on: {
      "click": function($event) {
        _vm.editSave('paramCk')
      }
    }
  }, [(_vm.submiting) ? _c('span', [_vm._v("提交中")]) : _c('span', [_vm._v("保存")]), _vm._v(" "), (_vm.submiting) ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e()]) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tip-div"
  }, [_c('span', {
    staticClass: "tip-red"
  }, [_vm._v("工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("出版许可证信息（请按照出版许可证上的信息填写）")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-581fe3e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pressRole/Audio_Electronic/forEdit/table2.vue
// module id = 1744
// module chunks = 1